import React from "react";
import { useCustomMutation } from "../hooks/useCustomMutation";
import axiosInstance from "../services/api";
import { useEffect, useRef } from "react";
import { Box, Image, IconButton, Flex, useBreakpointValue, Text, HStack } from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';
import { useDispatch, useSelector } from "react-redux";
import { setImageUrl } from "../redux/reducers/userSlice";
// import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'

function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}

const Promotions = () => {
    const { mutate } = useCustomMutation(axiosInstance);
    const [imagePromo, setImagePromo] = React.useState([]);
    const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
    const dispatch = useDispatch();

    const fetchPromotions = () => {
        mutate({
            url: `/Vendor/Getpromotions`,
            method: 'GET',
            onSuccess: (data) => {
                const imageUrls = data?.data?.map((item) => item?.promotionImageUrl);
                setImagePromo(imageUrls);
                dispatch(setImageUrl(imageUrls));
            }
        })
    }

    // const imagesPro = [
    //     'https://i.ibb.co/6cSdMj7B/Chat-GPT-Image-Apr-2-2025-09-22-37-AM.png',
    //     'https://i.ibb.co/JWsPRPjL/Cyon-cleanup.png',
    //     'https://i.ibb.co/4n7MsWw5/Whats-App-Image-2024-08-07-at-9-54-30-AM.jpg'
    // ]

    useEffect(() => {
        fetchPromotions();
    }, []);

    const handlePrev = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? imagePromo.length - 1 : prevIndex - 1
        );
       
    };

    const handleNext = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === imagePromo.length - 1 ? 0 : prevIndex + 1
        );
       
    };

    useInterval(() => {
        if (imagePromo.length > 0) {
            let randomIndex;
            do {
                randomIndex = Math.floor(Math.random() * imagePromo.length);
            } while (randomIndex === currentImageIndex);

            setCurrentImageIndex(randomIndex);
        }
    }, imagePromo.length > 0 ? 3000 : null);


    if (!imagePromo || imagePromo.length === 0) {
        return (
            <Box>
                <Text fontSize="xl" fontWeight="bold">
                    Loading......
                </Text>

            </Box>)
    }

    return (
        <>
            <Box position="relative" overflow="hidden">
                <Image
                    src={imagePromo[currentImageIndex]}
                    alt={`Image ${currentImageIndex + 1}`}
                    width="100%"
                    maxHeight="300px"
                    objectFit="cover"
                />

                <HStack
                    position="absolute"
                    top="50%"
                    transform="translateY(-50%)"
                    width="100%"
                    justifyContent="space-between"
                    padding="0 1rem"
                >
                    <IconButton
                        aria-label="Previous Image"
                        icon={<ArrowLeftIcon />}
                        onClick={handlePrev}
                        size="lg"
                        variant="ghost"
                        color="white"
                        _hover={{ bg: 'rgba(0, 0, 0, 0.2)' }}
                    />
                    <IconButton
                        aria-label="Next Image"
                        icon={<ArrowRightIcon />}
                        onClick={handleNext}
                        size="lg"
                        variant="ghost"
                        color="white"
                        _hover={{ bg: 'rgba(0, 0, 0, 0.2)' }}
                    />
                </HStack>
            </Box>
        </>
    )
}

export default Promotions;